(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // ==========================================================================
    // お気に入り
    // ==========================================================================
    // console.log("お気に入り");
    // console.log(localStorage.getItem("localFavoritePostID"));
    let existingData = JSON.parse(localStorage.getItem("localFavoritePostID")) || [];
    let optoutFlag = false;
    // console.log("optoutFlag");
    // console.log(optoutFlag);
    if (existingData.val == 1) {
      existingData = [];
      optoutFlag = true;
      // console.log("オプトアウトが設定されています");
      // console.log("optoutFlag");
      // console.log(optoutFlag);
    }
    // console.log("existingData:");
    // console.log(existingData);
    const siteDomain = document.domain;
    const siteUrl = "https://" + siteDomain + "/group/brand";
    let apiUrl = `${siteUrl}/wp-json/wp/v2/posts?include=${existingData.join(",")}`;
    // window.odakyuGroupBrand = window.odakyuGroupBrand || {};

    // let jsonDataFavorite;
    const $favoriteHeaderLists = $("#js-favorite-header-lists");
    const $favoriteHeaderLinkButton = $("#js-favorite-header-link-button");
    const $favoriteLists = $("#js-favorite-lists");
    const $favoriteDetailAddFilterButton = $("#js-favorite-detail-add-filter-button");
    const $favoriteDetailDeleteFilterButton = $("#js-favorite-detail-delete-filter-button");
    const $relatedLists = $("#js-related-lists");
    const $topicsLists = $("#js-topics-lists");
    const $jsLpLists = $("#js-lp-lists");

    if (existingData.length !== 0) {
      fetch(apiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok " + response.statusText);
          }
          return response.json();
        })
        .then((data) => {
          // window.odakyuGroupBrand.data = data;
          displayFavoriteData(data); // 表示関数
          // console.log(data);
          // document.dispatchEvent(new Event("dataLoaded"));
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });

      for (let i = 0; i < existingData.length; i++) {
        $('[data-favorite="' + existingData[i] + '"]').addClass("-favorite-active");
      }
    } else {
      // お気に入りが無いときの処理
      notFoundFavoriteData();
    }

    // お気に入り記事一覧
    // document.addEventListener("dataLoaded", function () {
    //   jsonDataFavorite = filterFavoriteData(window.odakyuGroupBrand.data); // フィルタリング
    //   displayFavoriteData(jsonDataFavorite); // 表示関数
    // });

    // 初回設定
    // if (existingData.indexOf($favoriteDetailAddFilterButton.data("set")) !== -1) {
    // すでに登録されている場合
    // $favoriteDetailAddFilterButton.fadeOut(0);
    // $favoriteDetailDeleteFilterButton.fadeIn(300);
    // }

    // ヘッダー
    $favoriteHeaderLists.on("click", ".js-favorite-delete-button", function () {
      favoriteProcessDelete($(this));
    });

    // 詳細
    $favoriteDetailAddFilterButton.click(function () {
      favoriteProcessAdd($(this));
    });
    $favoriteDetailDeleteFilterButton.click(function () {
      favoriteProcessDelete($(this));
    });

    // お気に入り一覧
    $favoriteLists.on("click", ".js-favorite-delete-post-button", function () {
      favoriteProcessDelete($(this));
    });

    // 関連記事
    $relatedLists.on("click", ".js-favorite-add-post-button", function () {
      favoriteProcessAdd($(this));
    });

    $relatedLists.on("click", ".js-favorite-delete-post-button", function () {
      favoriteProcessDelete($(this));
    });

    // TOPICS
    $topicsLists.on("click", ".js-favorite-add-post-button", function () {
      favoriteProcessAdd($(this));
    });

    $topicsLists.on("click", ".js-favorite-delete-post-button", function () {
      favoriteProcessDelete($(this));
    });

    // LP
    $jsLpLists.on("click", ".js-favorite-add-post-button", function () {
      favoriteProcessAdd($(this));
    });

    $jsLpLists.on("click", ".js-favorite-delete-post-button", function () {
      favoriteProcessDelete($(this));
    });

    // 各記事一覧
    $(".js-favorite-add-post-button").click(function () {
      favoriteProcessAdd($(this));
    });

    $(".js-favorite-delete-post-button").click(function () {
      favoriteProcessDelete($(this));
    });

    function favoriteProcessAdd(current) {
      if (!optoutFlag) {
        let postID = current.data("set"); // 記事ID取得
        // console.log(postID);
        let indexToRemove = existingData.indexOf(postID); // 削除したい要素のインデックスを見つける
        // インデックスがない場合は追加する
        if (indexToRemove == -1) {
          existingData.push(postID); // localStorageからデータを追加
        }
        localStorage.setItem("localFavoritePostID", JSON.stringify(existingData)); // 更新された配列をlocalStorageに保存する
        // console.log("[localStorage]", JSON.parse(localStorage.getItem("localFavoritePostID"))); // localStorageからデータを取得して確認する
        let apiUrl = `${siteUrl}/wp-json/wp/v2/posts?include=${existingData.join(",")}`;
        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok " + response.statusText);
            }
            return response.json();
          })
          .then((data) => {
            displayFavoriteData(data); // 表示関数
          })
          .catch((error) => {
            console.error("There was a problem with the fetch operation:", error);
          });

        $("[data-favorite]").removeClass("-favorite-active");
        for (let i = 0; i < existingData.length; i++) {
          $('[data-favorite="' + existingData[i] + '"]').addClass("-favorite-active");
        }
      }
    }

    function favoriteProcessDelete(current) {
      let postID = current.data("set"); // 記事ID取得
      let indexToRemove = existingData.indexOf(postID); // 削除したい要素のインデックスを見つける
      // インデックスが見つかった場合は削除する
      if (indexToRemove !== -1) {
        existingData.splice(indexToRemove, 1); // localStorageからデータを削除
      }
      localStorage.setItem("localFavoritePostID", JSON.stringify(existingData)); // 更新された配列をlocalStorageに保存する
      // console.log("[localStorage]", JSON.parse(localStorage.getItem("localFavoritePostID"))); // localStorageからデータを取得して確認する

      if (existingData.length !== 0) {
        let apiUrl = `${siteUrl}/wp-json/wp/v2/posts?include=${existingData.join(",")}`;
        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok " + response.statusText);
            }
            return response.json();
          })
          .then((data) => {
            displayFavoriteData(data); // 表示関数
          })
          .catch((error) => {
            console.error("There was a problem with the fetch operation:", error);
          });
      } else {
        // お気に入りが無いときの処理
        notFoundFavoriteData();
      }

      $("[data-favorite]").removeClass("-favorite-active");
      for (let i = 0; i < existingData.length; i++) {
        $('[data-favorite="' + existingData[i] + '"]').addClass("-favorite-active");
      }
    }

    // function filterFavoriteData(filter) {
    //   let filtered = filter;
    //   jsonDataFavorite = []; // 読み込んだJSONデータを変数に格納
    //   for (let i = 0; i < existingData.length; i++) {
    //     filtered.filter(function (item) {
    //       if (item.id === existingData[i]) {
    //         jsonDataFavorite.push(item);
    //       }
    //     });
    //   }
    //   filtered = jsonDataFavorite;
    //   return filtered;
    // }

    function displayFavoriteData(data) {
      const today = new Date();
      const twoWeeksLater = new Date(today);
      twoWeeksLater.setDate(today.getDate() - 14);

      // header内のマークアップ
      let output = "";
      data.forEach(function (value, index) {
        const postDate = new Date(value["date"]);
        const acfSeries = value["acf"]["field-series"];

        output += '<article class="l-header__menu-favorite-card__article">';
        output += '<div class="l-header__menu-favorite-card__article-wrap">';
        output += '<a class="l-header__menu-favorite-card__article-link" href="' + value["link"] + '">';
        output += '<span class="l-header__menu-favorite-card__article-header">';
        output += "<span>";
        output += '<span class="l-header__menu-favorite-card__article-cats">';
        if (postDate > twoWeeksLater) {
          output += '<span class="l-header__menu-favorite-card__article-cat -new">NEW</span>';
        }
        value["categories_info"].forEach(function (value, index) {
          output += '<span class="l-header__menu-favorite-card__article-cat">' + value["name"] + "</span>";
        });
        output += "</span>";
        output += '<span class="l-header__menu-favorite-card__article-body">';
        output += '<h3 class="l-header__menu-favorite-card__article-heading ' + value["slug"] + '">' + value["acf"]["field-title-html"] + "</h3>";
        output += '<img loading="lazy" class="l-header__menu-favorite-card__article-body-img" src="/group/brand/assets/img/article/' + value["slug"] + '/thumbnail01.jpg" width="416" height="260" alt="サムネイル画像">';
        output += "</span>";
        output += "</span>";
        output += '<img loading="lazy" class="l-header__menu-favorite-card__article-header-img" src="/group/brand/assets/img/article/' + value["slug"] + '/thumbnail01.jpg" width="416" height="260" alt="サムネイル画像">';
        output += "</span>";
        output += "</a>";
        output += '<span class="l-header__menu-favorite-card__article-footer">';
        output += '<span class="l-header__menu-favorite-card__article-tags">';
        value["tags_info"].forEach(function (value, index) {
          if (value["name"] === "PICK UP" || value["name"] === "SPECIAL ISSUE" || value["name"] === "INTERVIEW" || value["name"] === "VIDEO" || value["name"] === "INFOGRAPHIC") {
            output += '<span class="l-header__menu-favorite-card__article-tag">#' + value["name"] + "</span>";
          }
        });
        value["tags_info"].forEach(function (value, index) {
          if (value["name"] === acfSeries) {
            output += '<span class="l-header__menu-favorite-card__article-tag">#' + value["name"] + "</span>";
          }
        });
        value["tags_info"].forEach(function (value, index) {
          if (!(value["name"] === "PICK UP" || value["name"] === "SPECIAL ISSUE" || value["name"] === "INTERVIEW" || value["name"] === "VIDEO" || value["name"] === "INFOGRAPHIC" || value["name"] === acfSeries)) {
            output += '<span class="l-header__menu-favorite-card__article-tag">#' + value["name"] + "</span>";
          }
        });
        output += "</span>";
        output += '<svg data-set="' + value["id"] + '" class="js-favorite-delete-button l-header__menu-favorite-card__article-svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">';
        output +=
          '<path d="M4.39375 27.9755C4.58898 28.0788 4.80962 28.1302 5.03273 28.1246C5.25584 28.1189 5.47329 28.0563 5.6625 27.9433L15 22.3724L24.3375 27.9433C24.5267 28.0562 24.7441 28.1187 24.9672 28.1243C25.1902 28.1299 25.4108 28.0784 25.606 27.9751C25.8011 27.8719 25.9638 27.7206 26.077 27.5371C26.1903 27.3536 26.25 27.1445 26.25 26.9315V5.4545C26.25 4.50516 25.8549 3.5947 25.1517 2.92341C24.4484 2.25213 23.4946 1.875 22.5 1.875H7.5C6.50544 1.875 5.55161 2.25213 4.84835 2.92341C4.14509 3.5947 3.75 4.50516 3.75 5.4545V26.9315C3.74989 27.1446 3.80954 27.3537 3.92274 27.5373C4.03594 27.7209 4.19858 27.8722 4.39375 27.9755Z" fill="#004DA1"/>';
        output += "</svg>";
        output += "</span>";
        output += "</div>";
        output += "</article>";
      });
      $favoriteHeaderLists.html(output);
      $favoriteHeaderLinkButton.addClass("-active");

      // お気に入り一覧ページのマークアップ
      let output01 = '<div class="c-card__articles">';
      data.forEach(function (value, index) {
        const postDate = new Date(value["date"]);
        const acfSeries = value["acf"]["field-series"];

        output01 += '<article class="c-card__article" data-favorite="' + value["id"] + '">';
        output01 += '<a class="js-button-hover c-card__article-link" href="' + value["link"] + '">';
        output01 += '<span class="c-card__article-text-area">';
        output01 += '<span class="c-card__article-cats c-card__clip">';
        if (postDate > twoWeeksLater) {
          output01 += '<span class="c-card__article-cat -new">NEW</span>';
        }
        value["categories_info"].forEach(function (value, index) {
          output01 += '<span class="c-card__article-cat">' + value["name"] + "</span>";
        });
        output01 += "</span>";
        //
        output01 += '<span class="c-card__article-main">';
        output01 += '<span class="c-card__article-heading-wrap c-card__clip"><span class="c-card__article-heading ' + value["slug"] + '">' + value["acf"]["field-title-html"] + "</span></span>";
        output01 += '<img loading="lazy" class="c-card__article-img-sp c-card__opacity" src="/group/brand/assets/img/article/' + value["slug"] + '/thumbnail01.jpg" width="416" height="260" loding="lazy" alt="サムネイル画像">';
        output01 += "</span>";
        //
        output01 += "</span>";
        output01 += '<img loading="lazy" class="c-card__article-img-pc c-card__opacity" src="/group/brand/assets/img/article/' + value["slug"] + '/thumbnail.jpg" width="800" height="708" loding="lazy" alt="サムネイル画像">';
        output01 += '<span class="js-hover01 c-card__line -first"></span>';
        output01 += '<span class="js-hover02 c-card__line -second"></span>';
        output01 += '<span class="js-hover03 c-card__line -third"></span>';
        output01 += '<span class="js-hover04 c-card__line -fourth"></span>';
        output01 += "</a>";

        output01 += '<div class="js-hover-svg c-card__svg-hover">';
        output01 += '<svg class="-hover-svg-random01" xmlns="http://www.w3.org/2000/svg" width="481" height="345" viewBox="0 0 481 345" fill="none">';
        output01 +=
          '<path d="M510.634 336.868C476.778 264.8 436.796 255.72 394.774 266.636C317.726 290.481 244.73 288.285 176.845 231.198C108.959 174.112 84.182 17.9212 133.942 8.70344C183.702 -0.51428 188.71 111.142 139.09 174.065C106.255 215.703 41.0377 218.974 3.56545 217.111C-33.9068 215.249 -90.6686 204.87 -101.738 202.44" stroke="url(#svgid01)" stroke-width="16" stroke-linecap="round"/>';
        output01 += "<defs>";
        output01 += '<linearGradient id="svgid01" x1="59.6546" y1="73.531" x2="264.02" y2="144.338" gradientUnits="userSpaceOnUse">';
        output01 += '<stop stop-color="#5AB4E6"/>';
        output01 += '<stop offset="1" stop-color="#C7E5F1"/>';
        output01 += "</linearGradient>";
        output01 += "</defs>";
        output01 += "</svg>";
        output01 += '<svg class="-hover-svg-random02" xmlns="http://www.w3.org/2000/svg" width="479" height="134" viewBox="0 0 479 134" fill="none">';
        output01 += '<path d="M-11 74.9588C31.5 9.26001 200.5 -23.8391 128.5 50.1611C56.5 124.161 117.89 144.298 178.5 106.161C267.5 50.1611 361.5 16.1608 485 9.25979" stroke="url(#svgid02)" stroke-width="16" stroke-linecap="round"/>';
        output01 += "<defs>";
        output01 += '<linearGradient id="svgid02" x1="-1.90182" y1="109.226" x2="239.302" y2="109.226" gradientUnits="userSpaceOnUse">';
        output01 += '<stop stop-color="#5AB4E6"/>';
        output01 += '<stop offset="1" stop-color="#C7E5F1"/>';
        output01 += "</linearGradient>";
        output01 += "</defs>";
        output01 += "</svg>";
        output01 += '<svg class="-hover-svg-random03" xmlns="http://www.w3.org/2000/svg" width="478" height="227" viewBox="0 0 478 227" fill="none">';
        output01 += '<path d="M-161.501 184.5C-201.299 199.353 -95.9654 214.076 26.2012 217.966C376.059 229.107 408.999 57.9996 343.999 16.0002C278.999 -25.9993 282.999 116.222 396.999 92.9996C450.999 81.9996 486.999 43.9998 494.999 21.9998" stroke="url(#svgid03)" stroke-width="16" stroke-linecap="round"/>';
        output01 += "<defs>";
        output01 += '<linearGradient id="svgid03" x1="-10.4601" y1="120.748" x2="223.274" y2="120.748" gradientUnits="userSpaceOnUse">';
        output01 += '<stop stop-color="#5AB4E6"/>';
        output01 += '<stop offset="1" stop-color="#C7E5F1"/>';
        output01 += "</linearGradient>";
        output01 += "</defs>";
        output01 += "</svg>";
        output01 += '<svg class="-hover-svg-random04" xmlns="http://www.w3.org/2000/svg" width="481" height="309" viewBox="0 0 481 309" fill="none">';
        output01 +=
          '<path d="M-17.5246 300.332C-7.33989 283.971 27.3186 241.426 83.5667 276.924C139.815 312.421 228.208 233.227 223.578 180.153C218.948 127.078 165.204 116.172 133.805 135.224C102.406 154.275 104.139 216.422 145.553 237.515C186.966 258.607 276.442 277.098 375.192 208.894C473.941 140.691 490.53 7.99911 490.53 7.99911" stroke="url(#svgid04)" stroke-width="16" stroke-linecap="round"/>';
        output01 += "<defs>";
        output01 += '<linearGradient id="svgid04" x1="68.6069" y1="366.315" x2="272.576" y2="150.475" gradientUnits="userSpaceOnUse">';
        output01 += '<stop stop-color="#5AB4E6"/>';
        output01 += '<stop offset="1" stop-color="#C7E5F1"/>';
        output01 += "</linearGradient>";
        output01 += "</defs>";
        output01 += "</svg>";
        output01 += '<svg class="-hover-svg-random05" xmlns="http://www.w3.org/2000/svg" width="479" height="224" viewBox="0 0 479 224" fill="none">';
        output01 += '<path d="M-7.5 53.4994C146.5 -28.5002 366.5 -12.4999 488.5 215.5" stroke="url(#svgid05)" stroke-width="16" stroke-linecap="round"/>';
        output01 += "<defs>";
        output01 += '<linearGradient id="svgid05" x1="1.59818" y1="87.7674" x2="242.802" y2="87.7674" gradientUnits="userSpaceOnUse">';
        output01 += '<stop stop-color="#5AB4E6"/>';
        output01 += '<stop offset="1" stop-color="#C7E5F1"/>';
        output01 += "</linearGradient>";
        output01 += "</defs>";
        output01 += "</svg>";
        output01 += '<svg class="-hover-svg-random06" xmlns="http://www.w3.org/2000/svg" width="478" height="158" viewBox="0 0 478 158" fill="none">';
        output01 += '<path d="M-10.8309 13.4637C160.41 -19.9486 -26.9874 138.187 168.005 68.1154C237.075 47.3971 226.342 85.9429 236.249 115.112C246.157 144.281 279.629 154.51 309.17 146.807C332.803 140.645 480.456 98.4206 507.27 87.0959" stroke="url(#svgid06)" stroke-width="16" stroke-linecap="round"/>';
        output01 += "<defs>";
        output01 += '<linearGradient id="svgid06" x1="-11.7776" y1="40.849" x2="218.896" y2="111.342" gradientUnits="userSpaceOnUse">';
        output01 += '<stop stop-color="#5AB4E6"/>';
        output01 += '<stop offset="1" stop-color="#C7E5F1"/>';
        output01 += "</linearGradient>";
        output01 += "</defs>";
        output01 += "</svg>";
        output01 += "</div>";
        output01 += '<svg class="c-card__svg-display" xmlns="http://www.w3.org/2000/svg" width="479" height="157" viewBox="0 0 479 157" fill="none">';
        output01 += '<path d="M0.5 75.9597C40.5 75.9597 67 52.5009 121 22.0005C175 -8.49986 210 14.9186 175 75.9597C140 137.001 175 172 229 130.001C367.863 22.0005 440 76.0009 479.5 76.0009" stroke="url(#paint0_linear_1347_16975)" stroke-width="16" stroke-linecap="round"/>';
        output01 += "<defs>";
        output01 += '<linearGradient id="paint0_linear_1347_16975" x1="1.09818" y1="110.226" x2="480" y2="110.226" gradientUnits="userSpaceOnUse">';
        output01 += '<stop stop-color="#5AB4E6"/>';
        output01 += '<stop offset="0.4" stop-color="#C7E5F1"/>';
        output01 += '<stop offset="1" stop-color="#5AB4E6"/>';
        output01 += "</linearGradient>";
        output01 += "</defs>";
        output01 += "</svg>";

        output01 += '<div class="c-card__article-footer c-card__opacity">';

        output01 += '<p class="c-card__article-tags">';
        value["tags_info"].forEach(function (value, index) {
          if (value["name"] === "PICK UP" || value["name"] === "SPECIAL ISSUE" || value["name"] === "INTERVIEW" || value["name"] === "VIDEO" || value["name"] === "INFOGRAPHIC") {
            output01 += '<span class="c-card__article-tag">#' + value["name"] + "</span>";
          }
        });
        value["tags_info"].forEach(function (value, index) {
          if (value["name"] === acfSeries) {
            output01 += '<span class="c-card__article-tag">#' + value["name"] + "</span>";
          }
        });
        value["tags_info"].forEach(function (value, index) {
          if (!(value["name"] === "PICK UP" || value["name"] === "SPECIAL ISSUE" || value["name"] === "INTERVIEW" || value["name"] === "VIDEO" || value["name"] === "INFOGRAPHIC" || value["name"] === acfSeries)) {
            output01 += '<span class="c-card__article-tag">#' + value["name"] + "</span>";
          }
        });
        output01 += "</p>";

        output01 += '<span class="c-card__article-buttons">';
        output01 += '<svg class="js-favorite-delete-post-button c-card__article-svg" data-set="' + value["id"] + '" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">';
        output01 +=
          '<path d="M4.39375 27.9755C4.58898 28.0788 4.80962 28.1302 5.03273 28.1246C5.25584 28.1189 5.47329 28.0563 5.6625 27.9433L15 22.3724L24.3375 27.9433C24.5267 28.0562 24.7441 28.1187 24.9672 28.1243C25.1902 28.1299 25.4108 28.0784 25.606 27.9751C25.8011 27.8719 25.9638 27.7206 26.077 27.5371C26.1903 27.3536 26.25 27.1445 26.25 26.9315V5.4545C26.25 4.50516 25.8549 3.5947 25.1517 2.92341C24.4484 2.25213 23.4946 1.875 22.5 1.875H7.5C6.50544 1.875 5.55161 2.25213 4.84835 2.92341C4.14509 3.5947 3.75 4.50516 3.75 5.4545V26.9315C3.74989 27.1446 3.80954 27.3537 3.92274 27.5373C4.03594 27.7209 4.19858 27.8722 4.39375 27.9755Z" fill="#004DA1"></path>';
        output01 += "</svg>";
        output01 += "</span>";
        output01 += "</div>";
        output01 += "</article>";
      });
      output01 += "</div>";

      $favoriteLists.html(output01);
    }

    function notFoundFavoriteData() {
      let output = '<p class="p-archive-search__not-found -border-none"><span class="p-archive-search__not-found-icon"><img loading="lazy" class="p-archive-search__not-found-img" src="/group/brand/assets/img/icon_notfound_white.png" width="80" height="80" loding="lazy" alt="icon"></span>お気に入りした記事は見つかりませんでした。</p>';
      $favoriteHeaderLists.html(output);
      $favoriteHeaderLinkButton.removeClass("-active");
      let output01 = '<p class="p-archive-search__not-found -border-none"><span class="p-archive-search__not-found-icon"><img loading="lazy" class="p-archive-search__not-found-img" src="/group/brand/assets/img/icon_notfound.png" width="80" height="80" loding="lazy" alt="icon"></span>お気に入りした記事は見つかりませんでした。</p>';
      $favoriteLists.html(output01);
    }

    // ==========================================================================
    // 検索・お気に入りメニュー
    // ==========================================================================
    const openSearchButtons = document.querySelectorAll(".js-search-button");
    const openFavoriteButtons = document.querySelectorAll(".js-favorite-button");
    const searchMenu = document.querySelector(".js-search-menu");
    const favoriteMenu = document.querySelector(".js-favorite-menu");
    const $headerButtons = $("#js-header-buttons");
    const $footerElement = $(".l-footer");

    // 検索メニュー
    openSearchButtons.forEach((openButton) => {
      openButton.addEventListener("click", (e) => {
        updateMenuButtons("search");
      });
    });

    // お気に入りメニュー
    openFavoriteButtons.forEach((openButton) => {
      openButton.addEventListener("click", (e) => {
        updateMenuButtons("favorite");
      });
    });

    function updateMenuButtons(type) {
      // ラベル名：aria-label
      const searchOpenTxt = "検索メニューを開く";
      const searchCloseTxt = "検索メニューを閉じる";
      const favoriteOpenTxt = "お気に入りメニューを開く";
      const favoriteCloseTxt = "お気に入りメニューを閉じる";
      const isLabel01 = openSearchButtons[0].getAttribute("aria-label") === searchOpenTxt;
      const isLabel02 = openFavoriteButtons[0].getAttribute("aria-label") === favoriteOpenTxt;

      // 要素のグループ：aria-expanded
      const isExpanded01 = openSearchButtons[0].getAttribute("aria-expanded") === "true";
      const isExpanded02 = openFavoriteButtons[0].getAttribute("aria-expanded") === "true";

      // 検索メニュー：aria-hidden
      const isHidden01 = searchMenu.getAttribute("aria-hidden") === "true";
      const isHidden02 = favoriteMenu.getAttribute("aria-hidden") === "true";

      if (type === "search") {
        // ラベル名：aria-label
        openSearchButtons[0].setAttribute("aria-label", isLabel01 ? searchCloseTxt : searchOpenTxt);
        openFavoriteButtons[0].setAttribute("aria-label", favoriteOpenTxt);

        // 要素のグループ：aria-expanded
        openSearchButtons[0].setAttribute("aria-expanded", isExpanded01 ? false : "true");
        openFavoriteButtons[0].setAttribute("aria-expanded", "false");

        // 検索メニュー：aria-hidden
        searchMenu.setAttribute("aria-hidden", isHidden01 ? false : "true");
        favoriteMenu.setAttribute("aria-hidden", "false");
      }

      if (type === "favorite") {
        // ラベル名：aria-label
        openSearchButtons[0].setAttribute("aria-label", searchOpenTxt);
        openFavoriteButtons[0].setAttribute("aria-label", isLabel02 ? favoriteCloseTxt : favoriteOpenTxt);

        // 要素のグループ：aria-expanded
        openSearchButtons[0].setAttribute("aria-expanded", "false");
        openFavoriteButtons[0].setAttribute("aria-expanded", isExpanded02 ? false : "true");

        // 検索メニュー：aria-hidden
        searchMenu.setAttribute("aria-hidden", "false");
        favoriteMenu.setAttribute("aria-hidden", isHidden02 ? false : "true");
      }

      // body overflow hidden
      if (openSearchButtons[0].getAttribute("aria-expanded") === "true") {
        document.body.classList.add("-hidden");
        document.documentElement.classList.add("-html-hidden");
        // bodyScrollLock.disableBodyScroll(searchMenu);
      } else if (openFavoriteButtons[0].getAttribute("aria-expanded") === "true") {
        document.body.classList.add("-hidden");
        document.documentElement.classList.add("-html-hidden");
        // bodyScrollLock.disableBodyScroll(favoriteMenu);
      } else {
        document.body.classList.remove("-hidden");
        document.documentElement.classList.remove("-html-hidden");
        // bodyScrollLock.clearAllBodyScrollLocks();
      }

      // コンテンツ上部に移動
      searchMenu.scrollTo(0, 0);
      favoriteMenu.scrollTo(0, 0);
    }

    // スクロールに応じた追従
    let startPosition = 0;
    let footerPosition = 0;
    // スクロールしていないか判別用
    let scrollTimeout;

    window.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);

      let scroll = window.pageYOffset;
      // console.log("startPosition:" + startPosition + " / scroll:" + scroll);
      footerPosition = $footerElement.offset().top - $(window).height();
      // console.log("footerPosition:" + footerPosition);

      if (scroll < 300) {
        // ページ上部
        $headerButtons.removeClass("is-hide");
        // console.log("ページ上部");
      } else if (scroll > footerPosition) {
        // ページ下部判定 footer
        $headerButtons.removeClass("is-hide");
        // console.log(" ページ下部判定 footer");
      } else if (scroll < startPosition) {
        // 上スクロール（新規取得したスクロール量がstartPosition以下）
        $headerButtons.removeClass("is-hide");
        // console.log("上スクロール");
      } else {
        // 1stスクロール以上、下スクロール時
        $headerButtons.addClass("is-hide");
        // console.log("下スクロール");
      }

      startPosition = scroll;
      // console.log("startPosition:" + startPosition + " / scroll:" + scroll);

      scrollTimeout = setTimeout(function () {
        $headerButtons.removeClass("is-hide");
      }, 10000);
    });

    // ==========================================================================
    // 注目記事
    // ==========================================================================
    const attentionSwiper = new Swiper(".js-attention-slide", {
      slidesPerView: 1.2,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // when window width is >= 768px
        768: {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });
    // END

    // ==========================================================================
    //  ScrollTrigger
    // ==========================================================================

    const jsCardDisplayAnimationTrigger = document.querySelector(".js-card-display-animation-trigger");
    if (jsCardDisplayAnimationTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.utils.toArray(".js-card-display-animation-trigger").forEach((trigger) => {
        gsap.timeline({
          scrollTrigger: {
            trigger: trigger,
            start: "top 80%",
            end: "bottom 20%",
            // toggleClass: "-card-display-animation-start",
            // markers: true,
            toggleActions: "play none none none",
            onEnter: () => {
              if (!trigger.classList.contains("-card-display-animation-start")) {
                trigger.classList.add("-card-display-animation-start");
              }
            },
          },
        });
      });
    }

    const jsCardScrollEvent = document.querySelector(".js-card-scroll-event");
    if (jsCardScrollEvent) {
      gsap.utils.toArray(".js-card-scroll-event").forEach((trigger) => {
        gsap.timeline({
          scrollTrigger: {
            trigger: trigger,
            start: "top 20%",
            end: "bottom 40%",
            toggleClass: "-scroll-card-event",
            toggleActions: "play none none none",
          },
        });
      });
    }

    // ==========================================================================
    //   カード スクロール アニメーション
    // ==========================================================================
    let isProcessing = false;

    window.addEventListener("scroll", function () {
      if (isProcessing) return;

      let scrollTrigger = document.querySelector(".-scroll-card-event");
      let targetElement = document.querySelector(".js-card-scroll-svg");

      if (!scrollTrigger || !targetElement) return;

      isProcessing = true;

      let children = targetElement.children;
      if (children.length > 0) {
        let randomIndex = Math.floor(Math.random() * children.length);
        children[randomIndex].classList.add("-start", "-visible");
      }

      setTimeout(() => {
        Array.from(children).forEach((child) => {
          child.classList.remove("-visible");
        });
      }, 1000);

      setTimeout(() => {
        Array.from(children).forEach((child) => {
          child.classList.remove("-start");
        });
        isProcessing = false; // ここでリセット
      }, 3000);
    });

    // ==========================================================================
    //  hover
    // ==========================================================================
    const mql = window.matchMedia("(any-hover:hover)");
    if (mql.matches) {
      // about button
      document.querySelectorAll(".js-button-hover").forEach((elem) => {
        const jsHover01 = elem.querySelector(".js-hover01");
        const jsHover02 = elem.querySelector(".js-hover02");
        const jsHover03 = elem.querySelector(".js-hover03");
        const jsHover04 = elem.querySelector(".js-hover04");
        const jsHoverOut01 = elem.querySelector(".js-hover-out01");
        const jsHoverOut02 = elem.querySelector(".js-hover-out02");
        const jsHoverOut03 = elem.querySelector(".js-hover-out03");
        const jsHoverOut04 = elem.querySelector(".js-hover-out04");

        const hoverTimeline = gsap.timeline({ paused: true });
        const hoverTimeline01 = gsap.timeline({ paused: true });
        const leaveTimeline = gsap.timeline({ paused: true });
        const leaveTimeline01 = gsap.timeline({ paused: true });

        if (jsHoverOut01) {
          // 左 hover
          hoverTimeline
            .to(jsHover01, {
              height: "100%",
              duration: 0.2,
            })
            .to(jsHover02, {
              width: "100%",
              duration: 0.2,
              delay: 0.05,
            });
          // 右 hover
          hoverTimeline01
            .to(jsHover03, {
              height: "100%",
              duration: 0.2,
            })
            .to(jsHover04, {
              width: "100%",
              duration: 0.2,
              delay: 0.05,
            });

          // 左 hover Out
          leaveTimeline
            .to(jsHoverOut01, {
              height: "100%",
              duration: 0.2,
            })
            .to(jsHoverOut02, {
              width: "100%",
              duration: 0.2,
              delay: 0.05,
            })
            .to(jsHover01, {
              height: "0",
              duration: 0,
            })
            .to(jsHover02, {
              width: "0",
              duration: 0,
            })
            .to(jsHoverOut01, {
              height: "0",
              duration: 0,
            })
            .to(jsHoverOut02, {
              height: "0",
              duration: 0,
            });

          // 右 hover Out
          leaveTimeline01
            .to(jsHoverOut03, {
              height: "100%",
              duration: 0.2,
            })
            .to(jsHoverOut04, {
              width: "100%",
              duration: 0.2,
              delay: 0.05,
            })
            .to(jsHover03, {
              height: "0",
              duration: 0,
            })
            .to(jsHover04, {
              width: "0",
              duration: 0,
            })
            .to(jsHoverOut03, {
              height: "0",
              duration: 0,
            })
            .to(jsHoverOut04, {
              height: "0",
              duration: 0,
            });
        } else {
          hoverTimeline
            .to(jsHover01, {
              height: "100%",
              duration: 0.2,
            })
            .to(jsHover02, {
              width: "100%",
              duration: 0.2,
              delay: 0.05,
            });

          // 右 hover
          hoverTimeline01
            .to(jsHover03, {
              height: "100%",
              duration: 0.2,
            })
            .to(jsHover04, {
              width: "100%",
              duration: 0.2,
              delay: 0.05,
            });

          // 左 hover Out
          leaveTimeline
            .to(jsHover02, {
              width: "0",
              duration: 0.2,
            })
            .to(jsHover01, {
              height: "0",
              duration: 0.2,
              delay: 0.05,
            });

          // 右 hover Out
          leaveTimeline01
            .to(jsHover04, {
              width: "0",
              duration: 0.2,
            })
            .to(jsHover03, {
              height: "0",
              duration: 0.2,
              delay: 0.05,
            });
        }

        // マウスが要素に入ったときのアニメーション
        elem.addEventListener("mouseenter", () => {
          let nextElement = elem.nextElementSibling;
          if (nextElement && nextElement.classList.contains("js-hover-svg")) {
            if (nextElement) {
              let children = nextElement.children;
              if (children.length > 0) {
                let randomIndex = Math.floor(Math.random() * children.length);
                children[randomIndex].classList.add("-start");
              }
            }
          }

          hoverTimeline.progress(0).play();
          hoverTimeline01.progress(0).play();
        });

        // マウスが要素から出たときのアニメーション
        elem.addEventListener("mouseleave", () => {
          let nextElement = elem.nextElementSibling;
          if (nextElement) {
            if (nextElement && nextElement.classList.contains("js-hover-svg")) {
              Array.from(nextElement.children).forEach((child) => {
                child.classList.remove("-start");
              });
            }
          }

          leaveTimeline.progress(0).play();
          leaveTimeline01.progress(0).play();
        });
      });
    }
    // END

    // ==========================================================================
    //  右クリック禁止
    // ==========================================================================
    const noContext = document.getElementById("js-noContext");

    noContext.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    // END

    // ==========================================================================
    //  magnificPopup
    // ==========================================================================
    $(".image-popup").magnificPopup({
      type: "image",
      closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close"></button>',
    });
    // END

    // ==========================================================================
    //  lazyload
    // ==========================================================================
    lazyload();
  });

  // END
})();
